import React, { useRef, useMemo, useState } from "react"
import { connect } from "react-redux"
import TableL2LContainer from "../../../common/TableL2LContainer"
import TableContainer from "../../../common/TableContainer"
import { SelectColumnFilter } from "../../../../filters/SelectColumnFilter"
import { Container } from "reactstrap"
import { getFormatedDate } from "../../../../utils/FormatedDate"
import { setEmtyIfNull } from "../../../../utils/getIfEmpty"
import history_icon from "../../../../assets/svg/history_icon.svg"
import list_icon from "../../../../assets/svg/list_icon.svg"
import {
  addToPrintList,
  removeFromPrintList,
} from "../../../../actions/BarcodeActions"

import "./style.scss"

const L2LShopOrdersList = ({
  shopOrderList,
  ordersStatusesArr,
  userData,
  isLoading,
  onHistoryClick,
  onCancelOrderClick,
  extendPackageClick,
  refreshTable,
  printAllSelectedBarcodes,
  onTransferOrderClick,
  onPDFClick,
  removeFromPrintList,
  orderNumbersForPrint,
  addToPrintList,
  lastOrdersUpdate,
}) => {
  const [filterValue, setFilterValue] = useState("")
  const [hiddenColumns] = useState(["orderStatusId"])
  const [visibleRows, setVisibleRows] = useState([])
  const visibleRowsRef = useRef([])

  const handleCheckboxChange = (event, packageNumber, orderNumber) => {
    const isChecked = event.target.checked
    if (isChecked) {
      addToPrintList(packageNumber, orderNumber)
    } else {
      removeFromPrintList(packageNumber, orderNumber)
    }
  }

  const handleSelectAllVisible = (checked) => {
    const currentVisibleRows = visibleRowsRef.current
    currentVisibleRows.forEach((row) => {
      const { packageNumber, orderNumber, orderStatus } = row.original
      if (packageNumber !== "" && orderStatus !== "מבוטל") {
        if (checked) {
          addToPrintList(packageNumber, orderNumber)
        } else {
          removeFromPrintList(packageNumber, orderNumber)
        }
      }
    })
  }

  const eligibleVisibleRows = visibleRows.filter(
    (row) =>
      row.original.packageNumber !== "" && row.original.orderStatus !== "מבוטל"
  )

  const allVisibleSelected =
    eligibleVisibleRows.length > 0 &&
    eligibleVisibleRows.every((row) =>
      orderNumbersForPrint?.includes(row.original.orderNumber)
    )

  const formattedOrders = useMemo(() => {
    if (!shopOrderList) return []

    return shopOrderList.map((order) => ({
      ...order,
      mobilePhone: setEmtyIfNull(order.mobilePhone),
      firstName: setEmtyIfNull(order.firstName),
      lastName: setEmtyIfNull(order.lastName),
      email: setEmtyIfNull(order.email),
      orderStatus: ordersStatusesArr[order.orderStatus],
      orderDate: getFormatedDate(order.orderDate),
      inLockerExtentionDate: getFormatedDate(order.inLockerExtentionDate),
      orderStatusId: order.orderStatus,
      customerSource:
        order.customerSource?.firstName + " " + order.customerSource?.lastName,
      customerTarget:
        order.customerTarget?.firstName + " " + order.customerTarget?.lastName,
    }))
  }, [shopOrderList, ordersStatusesArr])

  const columns = useMemo(() => {
    const baseColumns = [
      { Header: "תאריך", accessor: "orderDate" },
      { Header: "מספר הזמנה", accessor: "orderNumber" },
      { Header: "מספר חבילה", accessor: "externalOrderNumber" },
      {
        Header: "סטטוס",
        accessor: "orderStatus",
        Filter: SelectColumnFilter,
        filter: filterValue,
      },
      { Header: "שם שולח", accessor: "customerSourceFullName" },
      { Header: "עמדת מקור", accessor: "stationSourceName" },
      { Header: "שם נמען", accessor: "customerTargetFullName" },
      { Header: "עמדת יעד", accessor: "stationTargetName" },
      { Header: "אימייל נמען", accessor: "customerTargetEmail" },
      { Header: "נוצר על ידי", accessor: "createdByName" },
      { Header: "תאריך הארכה", accessor: "inLockerExtentionDate" },
    ]

    const actionColumns = [
      {
        Header: () => null,
        id: "key",
        Cell: ({ row }) => (
          <img
            className="order-edit"
            alt="edit_button"
            src={history_icon}
            onClick={() => onHistoryClick(row)}
          />
        ),
      },
      {
        Header: () => null,
        id: "cancel_order",
        Cell: ({ row }) => {
          const { orderStatusId } = row.original
          return (
            (orderStatusId === 19 || orderStatusId === 18) && (
              <i
                className="fas fa-trash order-edit"
                onClick={() => onCancelOrderClick(row.original)}
              ></i>
            )
          )
        },
      },
      {
        Header: () => null,
        id: "delay",
        Cell: ({ row }) => {
          const { orderStatusId } = row.original
          return (
            [3, 4, 13].includes(orderStatusId) && (
              <i
                className="fa fa-calendar"
                onClick={() => extendPackageClick(row.original)}
              ></i>
            )
          )
        },
      },
      {
        Header: () => null,
        id: "print",
        Cell: ({ row }) => (
          <i
            className="fas fa-print order-edit"
            onClick={() => onPDFClick(row)}
          ></i>
        ),
      },

      {
        Header: () => (
          <input
            type="checkbox"
            onChange={(e) => handleSelectAllVisible(e.target.checked)}
            checked={allVisibleSelected}
            aria-label="select_all_visible"
          />
        ),
        id: "check_print",
        Cell: ({ row }) => {
          const packageNumber = row.original.packageNumber
          const orderNumber = row.original.orderNumber
          return packageNumber !== "" && row.original.orderStatus != "מבוטל" ? (
            <input
              type="checkbox"
              onChange={(event) =>
                handleCheckboxChange(event, packageNumber, orderNumber)
              }
              checked={orderNumbersForPrint?.includes(orderNumber)}
              aria-label="print_checkbox"
            />
          ) : null
        },
      },

      {
        Header: () => null,
        id: "transfer_order_l2l",
        Cell: ({ row }) => {
          const { orderStatusId } = row.original
          return (
            (orderStatusId === 4 || orderStatusId === 13) && (
              <i
                className="fa fa-random"
                onClick={() => onTransferOrderClick(row.original)}
              ></i>
            )
          )
        },
      },
    ]

    return [...actionColumns, ...baseColumns]
  }, [
    filterValue,
    userData?.accountType,
    onHistoryClick,
    onCancelOrderClick,
    extendPackageClick,
    onPDFClick,
    onTransferOrderClick,
    orderNumbersForPrint,
  ])

  const clearFilterAndRefreshTable = () => {
    setFilterValue("")
    refreshTable()
  }

  return (
    <div className="order-list-l2l-wrapper">
      <Container className="order-list-l2l">
        <TableContainer
          columns={columns}
          hiddenColumns={hiddenColumns}
          data={formattedOrders}
          userData={userData}
          refreshTable={clearFilterAndRefreshTable}
          filterValue={filterValue}
          printAllSelectedBarcodes={() => printAllSelectedBarcodes()}
          resetFilterValue={() => setFilterValue("")}
          isLoading={isLoading}
          lastOrdersUpdate={lastOrdersUpdate}
          onVisibleRowsChange={(rows) => {
            setVisibleRows(rows)
            visibleRowsRef.current = rows
          }}
        />
      </Container>
    </div>
  )
}

const mapStateToProps = ({
  orders,
  orderStatuses,
  users,
  station,
  barcode,
}) => ({
  shopOrderList: orders.shopOrderList,
  lastOrdersUpdate: orders.lastOrdersUpdate,
  ordersStatusesArr: orderStatuses.ordersStatusesArr,
  userData: users.userData,
  selectedStation: station.selectedStation,
  isLoading: barcode.isLoading,
  packageNumbersForPrint: barcode.packageNumbersForPrint,
  orderNumbersForPrint: barcode.orderNumbersForPrint,
})

export default connect(mapStateToProps, {
  addToPrintList,
  removeFromPrintList,
})(L2LShopOrdersList)
